import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/initialize/registerComponents'
import '@/initialize/installModules'
import * as api from '@immosparrow/cockpit-api-v2'
import { middlewareAxios } from '@immosparrow/cockpit-middleware-client'

api.init(process.env.VUE_APP_BASE_URL)
middlewareAxios.defaults.baseURL = process.env.VUE_APP_BASE_URL

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
